// FIX-CCS-A2-PLUMBING (unit A2, R17) — the phone's clock gap, for Stage C.
//
// gap_ms = phone clock minus server clock, measured from the server_now field that
// validate_session, verify_pin, upload-photo (every reply) and award-points now return.
// Positive = the phone is ahead. Kept in memory and in localStorage so the last measurement
// survives an offline app restart. Nothing reads it yet (Stage C will), so this changes no
// behaviour; a missing or unparseable server_now is simply ignored.

const STORAGE_KEY = 'agxl_server_clock_gap';

export interface ServerClockGap {
  gap_ms: number;
  server_now: string;
  phone_now: string;
  source: string;
}

let current: ServerClockGap | null = readStored();

function readStored(): ServerClockGap | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ServerClockGap;
    return typeof parsed?.gap_ms === 'number' && typeof parsed?.server_now === 'string' ? parsed : null;
  } catch {
    return null;
  }
}

/** Record the gap from one server reply. Returns the stored measurement, or null if server_now was unusable. */
export function recordServerNow(serverNow: unknown, source: string, phoneNowMs: number = Date.now()): ServerClockGap | null {
  if (typeof serverNow !== 'string') return null;
  const serverMs = Date.parse(serverNow);
  if (Number.isNaN(serverMs)) return null;
  const gap: ServerClockGap = {
    gap_ms: phoneNowMs - serverMs,
    server_now: serverNow,
    phone_now: new Date(phoneNowMs).toISOString(),
    source,
  };
  current = gap;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(gap));
  } catch {
    /* storage full or blocked — the in-memory value still holds */
  }
  return gap;
}

/** The last measured gap (memory first, then localStorage), or null if never measured. */
export function getServerClockGap(): ServerClockGap | null {
  return current ?? readStored();
}
